// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__7v5HM","location":"Header_location__zNY2y"};